const markApplications = [
    {
        "id": "1",
        "applyDate": "2022-01-15T00:00:00.000+08",
        "labelStyle": "sticker",
        "appFormNo": "20210607-01",
        "applicant": "楊小花",
        "operatorName": "楊小花",
        "contactPerson": "楊小花",
        "contactPhone": "0912345678",
        "estimateUsePeriodStart": "2022-01-15T00:00:00.000+08",
        "estimateUsePeriodEnd": "2023-05-15T00:00:00.000+08",
        "shippingWay": "house",
        "labelDeliverAddress": {
            "zip": "11501",
            "city": "taipei",
            "district": "南港區",
            "street": "三重路19-11號5樓"
        },
        "pastDeliverAddress": [
            {
                "zip": "11008",
                "city": "taipei",
                "district": "信義區",
                "street": "市府路1號"
            },
            {
                "zip": "204",
                "city": "keelung",
                "district": "仁愛區",
                "street": "仁愛路11號1樓"
            }
        ],
        "applyItems": [
            {
                "certificateLevel": "organic",
                "productionPeriod": "3月至9月",
                "estimatedProduction": 5,
                "packingWeight": 75,
                "packingSpec": "gram",
                "estimatedMarkNumber": 67,
                "actualMarkNumber": 67
            },
            {
                "certificateLevel": "transition",
                "productionPeriod": "4月至11月",
                "estimatedProduction": 500,
                "packingWeight": 30,
                "packingSpec": "tw-catty",
                "estimatedMarkNumber": 28,
                "actualMarkNumber": 28
            }
        ],
        "applyDetailSummary": [
            {
                "labelType": "單標章",
                "applyNumber": 2000,
            },
            {
                "labelType": "雙標章",
                "applyNumber": 2000,
            },
            {
                "labelType": "轉型期",
                "applyNumber": 3000,
            }
        ]
    },
    {
        "id": "2",
        "applyDate": "2022-01-17T00:00:00.000+08",
        "labelStyle": "overPrinter",
        "appFormNo": "20210607-02",
        "allowedOverprintMark": true,
        "contactPerson": "王大同",
        "contactPhone": "0987654321",
        "estimateUsePeriodStart": "2022-01-15T00:00:00.000+08",
        "estimateUsePeriodEnd": "2022-06-15T00:00:00.000+08",
        "applyDetailSummary": [
            {
                "labelType": "單標章",
                "applyNumber": 3000,
            },
            {
                "labelType": "雙標章",
                "applyNumber": 5000,
            },
            {
                "labelType": "轉型期",
                "applyNumber": 5000,
            }
        ]
    },
]

export default markApplications